"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgCallHangUp = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m4.43 9.32-.007.03-.007.022-2.373.176c-.031-.309-.053-.671-.053-1.086v-.317c0-.586.273-.834.458-.9C3.565 6.842 5.413 6.378 8 6.378c2.587 0 4.435.464 5.552.865.185.067.458.315.458.9v.318c0 .415-.022.777-.053 1.086l-2.373-.176-.007-.023-.008-.028c-.009-.03-.03-.103-.06-.188-.062-.166-.202-.5-.516-.81-.39-.384-.872-.583-1.317-.694C9.22 7.516 8.67 7.461 8 7.461c-.67 0-1.22.055-1.676.168-.445.111-.927.31-1.317.694-.314.31-.455.644-.515.81a2.893 2.893 0 0 0-.061.188Zm9.792-3.96c-1.319-.474-3.393-.983-6.222-.983-2.829 0-4.903.509-6.222.983C.616 5.777 0 6.93 0 8.145v.317c0 1.136.138 1.977.261 2.5.102.435.51.688.938.656l4.033-.3a.996.996 0 0 0 .873-.692l.216-.674.016-.055c.023-.08.037-.12.063-.145.046-.045.155-.118.402-.18.247-.061.624-.11 1.198-.11s.951.049 1.198.11c.247.062.356.135.402.18.026.026.04.067.063.145l.016.055.216.674c.123.388.469.662.873.692l4.033.3c.428.032.835-.22.938-.656.123-.523.261-1.364.261-2.5v-.317c0-1.216-.616-2.368-1.778-2.785Z" }))); };
exports.default = SvgCallHangUp;
